module.exports = __webpack_public_path__ + "static/media/32311603723640_.pic_hd.6902f4aa.jpg";